import {
  fetchCurrentUser,
  getAccountComputeBalance,
  getAccountPaymentEntitlement,
  type AccountComputeBalance,
  type AccountPaymentEntitlement,
} from '../api';
import { useAppStore } from '../store';
import {
  dispatchAccountEntitlementUpdated,
  dispatchAccountPaymentDataUpdated,
} from './accountPaymentEvents';
export {
  ACCOUNT_ENTITLEMENT_UPDATED_EVENT,
  ACCOUNT_PAYMENT_DATA_UPDATED_EVENT,
} from './accountPaymentEvents';

export interface AccountPaymentRefreshResult {
  entitlement: AccountPaymentEntitlement | null;
  computeBalance: AccountComputeBalance | null;
}

export async function refreshAccountPaymentData(): Promise<AccountPaymentRefreshResult> {
  const currentAvatar = useAppStore.getState().auth.user?.avatar;
  const [userPayload, entitlementPayload, computeBalancePayload] = await Promise.all([
    fetchCurrentUser().catch(() => null),
    getAccountPaymentEntitlement().catch(() => null),
    getAccountComputeBalance().catch(() => null),
  ]);

  if (userPayload) {
    useAppStore.getState().setAuthSession({
      userId: userPayload.user_id,
      user: {
        id: userPayload.user_id,
        nickname: userPayload.username,
        phone: userPayload.phone,
        isAdmin: Boolean(userPayload.is_admin),
        avatar: currentAvatar,
      },
    });
  }

  dispatchAccountEntitlementUpdated({ active: Boolean(entitlementPayload?.active) });
  dispatchAccountPaymentDataUpdated({
    active: Boolean(entitlementPayload?.active),
    computeBalance: computeBalancePayload?.balance ?? null,
    entitlement: entitlementPayload || null,
  });

  return {
    entitlement: entitlementPayload || null,
    computeBalance: computeBalancePayload || null,
  };
}
